<template>
<div class="box">
  <div class="columns">
      <div class="column is-4 news-menu">
          <div v-for="(nw,n) in news" :key="n" class="is-clickable is-hovered px-3 py-2" @click="selected=nw">
              <h3 :class="['has-text-left', 'title', 'has-text-grey', 'is-5']">{{nw.title}}</h3>
              <p :class="['subtitle', 'is-6', 'has-text-dark', 'has-text-justified', 'is-hidden-touch']">{{nw.text.slice(0,85)}}...</p>
          </div>
      </div>
      <div class="column has-background-dark has-text-justified">
          <h2 :class="['title', 'has-text-'+selected.titleColor, 'has-text-centered']">{{selected.title}}</h2>
          <p class="has-text-justified has-text-light">{{selected.text}}</p>
          <a :href="selected.link" class="has-text-info">Ir a ver -></a>
          <p :class="['mu-font', 'is-uppercase', 'is-size-1', 'has-text-'+selected.letterColor, 'has-text-centered']">{{selected.letter}}</p>
      </div>
  </div>
</div>
</template>

<script>
import News from '@/store/news'
export default {
    name: 'NewsPage',
    data:()=>({
        news: [],
        selected: {}
    }),
    beforeCreate(){
        this.$store.commit('setLoader', true)
        this.$store.dispatch('setPage', {
            location:{name:'news',number:6},
            title:'Lo nuevo de MUCRISIS',
            breadcrumb:[
                {name:'inicio',link:this.$store.state.baseUrl,active:true, icon:'home'},
                {name:'Novedades',link:'/novedades',active:false, icon:'newspaper'}
            ]
        })
    },
    mounted() {
        let tempNews = News
        if (tempNews.length > 0) this.selected = tempNews[0]
        for (var n in tempNews) {
            tempNews[n].link = this.$store.state.baseUrl + tempNews[n].link
            this.news.push(tempNews[n])
        }
        this.$store.commit('setLoader', false)
    }
}
</script>

<style scoped>
    .news-menu {
        max-height: 35.5rem;
        overflow-y: auto;
    }
    @media screen and (max-width:1023px) {
        .news-menu {
            max-height: 10.2rem;
        }
    }
    @media screen and (min-width:1024px) {
        .news-menu {
            max-height: 24.2rem;
        }
    }
    @media screen and (min-width:1279px) {
        .news-menu {
            max-height: 21.2rem;
        }
    }
    @media screen and (min-width:1401px) {
        .news-menu {
            max-height: 32.2rem;
        }
    }
    @media screen and (min-width:1679px) {
        .news-menu {
            max-height: 35.6rem;
        }
    }
    .is-hovered {
        transition: background-color .6s;
    }
    .is-hovered:hover {
        background-color: hsla(0, 0%, 0%, .2);
    }
</style>